export default {
  data: () => ({
    search: null,
    selectedTag: null,
    campaignId: null,
    creatorId: null,
    sortBy: '-most_used',
    filterBy: null,
    showDisabledCampaigns: false,
    campaignTags: [],
    sortByItems: [
      {
        text: 'Alphabetically',
        value: 'alphabetically'
      },
      {
        text: 'Date added',
        value: '-date_added'
      },
      {
        text: 'Most used',
        value: '-most_used'
      },
    ],
  }),
  computed: {
    availableTags () {
      const { campaignTags, selectedTag } = this
      let tags = []

      if (selectedTag !== null) { tags.push({ id: null, name: 'All' }) }
      tags.push(...campaignTags)

      return tags
    },
    filterByItems () {
      const { filterBy } = this
      const items = [
        {
          text: 'Automated campaigns',
          value: 'automated',
        },
        {
          text: 'Zero-Waste campaigns',
          value: 'zero_waste',
        },
      ]

      let tags = []

      if (filterBy !== null) { tags.push({ value: null, text: 'All' }) }
      
      tags.push(...items)
      return tags
    },
    queryParams () {
      const { search, selectedTag, sortBy, filterBy, showDisabledCampaigns, campaignId, creatorId } = this;

      return {
        query: search,
        sort: sortBy,
        id: campaignId,
        created_by: creatorId,
        with_disabled: showDisabledCampaigns,
        filter_by: filterBy,
        tag_ids: selectedTag,
      }
    },
  },
  watch: {
    search: {
      immediate: false,
      handler: function (val) {
        sessionStorage.setItem('campaignsSearch', val || '')
      },
    },
    campaignId: {
      immediate: false,
      handler: function (val) {
        sessionStorage.setItem('campaignCampaignId', val || '')
      },
    },
    creatorId: {
      immediate: false,
      handler: function (val) {
        sessionStorage.setItem('campaignCreatorId', val || '')
      },
    },
    selectedTag: {
      immediate: false,
      handler: function (val) {
        sessionStorage.setItem('campaignsSelectedTag', val || '')
      },
    },
    filterBy: {
      immediate: false,
      handler: function (val) {
        sessionStorage.setItem('campaignsFilterBy', val || '')
      },
    },
    sortBy: {
      immediate: false,
      handler: function (val) {
        sessionStorage.setItem('campaignsSortBy', val || '-most_used')
      },
    },
    showDisabledCampaigns: {
      immediate: false,
      handler: function (val) {
        sessionStorage.setItem('campaignsShowDisabled', val || false)
      },
    },
    campaignTags: {
      immediate: false,
      handler: function (val) {
        sessionStorage.setItem('campaignsTags', JSON.stringify(val ?? []))
      },
    },
  },
  mounted () {
    this.handleMounted()
  },
  methods: {
    handleMounted () {
      const sessionSearch = sessionStorage.getItem('campaignsSearch') ?? null
      const sessionSelectedTag = sessionStorage.getItem('campaignsSelectedTag') ?? null
      const sessionSortBy = sessionStorage.getItem('campaignsSortBy') ?? '-most_used'
      const sessionFilterBy = sessionStorage.getItem('campaignsFilterBy') ?? null
      const sessionShowDisabled = sessionStorage.getItem('campaignsShowDisabled') ?? false
      const sessionCampaignId = sessionStorage.getItem('campaignCampaignId') ?? null
      const sessionCreatorId = sessionStorage.getItem('campaignCreatorId') ?? null
      const sessionTags = JSON.parse(sessionStorage.getItem('campaignsTags'))  ?? []

      if (sessionSearch && sessionSearch !== 'null') this.search = sessionSearch
      if (sessionSortBy && sessionSortBy !== 'null') this.sortBy = sessionSortBy
      if (sessionFilterBy && sessionFilterBy !== 'null') this.filterBy = sessionFilterBy
      if (sessionCampaignId && sessionCampaignId !== 'null') this.campaignId = Number(sessionCampaignId)
      if (sessionCreatorId && sessionCreatorId !== 'null') this.creatorId = Number(sessionCreatorId)
      if (sessionTags?.length) this.campaignTags = sessionTags
      if (sessionSelectedTag && sessionSelectedTag !== 'null')
        this.selectedTag = Number(sessionSelectedTag)
      if (sessionShowDisabled && sessionShowDisabled !== 'null')
        this.showDisabledCampaigns = sessionShowDisabled === 'true'
    },
  },
}
